<template>
  <span class="task-name">
    <span v-if="isEdit === false" class="task-edit">
      <a-tooltip placement="top" :title="name">
        <a class="task-edit_name" target="_blank">{{ name }}</a>
      </a-tooltip>
      <a-icon class="task-edit_icon" type="edit" @click="onEdit" />
    </span>
    <a-input v-else ref="name" v-model="value" size="small" @blur="onBlur" />
  </span>
</template>

<script>
import { modifyTicketFlag } from '@/api/event/problem';
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    taskId: {
      type: [String, Number],
      default: null
    },
    // eslint-disable-next-line vue/prop-name-casing
    project_id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      value: null,
      isEdit: false
    };
  },
  computed: {

  },
  methods: {
    onEdit() {
      this.value = this.name;
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.name.focus();
      });
    },
    onBlur() {
      if (this.value === '' || this.value === this.name) {
        this.isEdit = false;
        return;
      }
      const req = {
        'id': this.taskId,
        'handler': '',
        'maintainer': '',
        'tags': '',
        'level': '',
        'status': '',
        'domain': '',
        'name': this.value
      };
      modifyTicketFlag({ req }).then(() => {
        this.isEdit = false;
        this.$emit('callback');
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-input-sm {
  width: calc(~'100% * 3');
  max-width: 440px;
}

.task-edit_name {
  color: rgba(0, 0, 0, 0.65);
  line-height: 30px;
  max-width: 600px;
  display: inline-block;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) 需与 overflow:hidden;一起使用。*/
}

.task-edit_icon {
  opacity: 0;
  // float: left;
  padding-top: 4px;
  padding-left: 2px;
}
.task-edit:hover {
  .task-edit_name {
    cursor: pointer;
    color: #3582fb;
  }
  .task-edit_icon {
    opacity: 1;
  }
}
</style>
